import { EuiListGroupItem, EuiIcon } from "@elastic/eui"
import CESgv from '../../../../../shared/Icons/CE.svg';
import DGSgv from '../../../../../shared/Icons/DG.svg';
import SGSgv from '../../../../../shared/Icons/SG.svg';
import DESgv from '../../../../../shared/Icons/DE.svg';
import D2Sgv from '../../../../../shared/Icons/D2.svg';
import DNSgv from '../../../../../shared/Icons/DN.svg';
import CTSgv from '../../../../../shared/Icons/CT.svg';
import { useMemo } from "react";

export const ItemList = (props:any) =>{

    const {data, onClickItem, actions, onRemoveItem, active} = props;

    const onClick = ()=>{
        onClickItem(data)
    }

    const getRemoveAction = ():any =>{
        if(onRemoveItem){
            return {
                color: 'danger',
                onClick: ()=> onRemoveItem(data),
                iconType: 'crossInACircleFilled',
                iconSize: 's',
                'aria-label': 'Eliminar centro',
                alwaysShow: true
                }
        }else{return {}}
    }

    const TipoCentroIcon = ():any =>{
        switch (data.tipoCentro) {
            case 'CE':
                return <EuiIcon type={CESgv} size='l'/>;
            case 'DG':
                return <EuiIcon type={DGSgv} size='l'/>;
            case 'SG':
                return <EuiIcon type={SGSgv} size='l'/>;
            case 'DE':
                return <EuiIcon type={DESgv} size='l'/>;
            case 'D2':
                return <EuiIcon type={D2Sgv} size='l'/>;
            case 'DN':
                return <EuiIcon type={DNSgv} size='l'/>;
            case 'CT':
                return <EuiIcon type={CTSgv} size='l'/>;
        
            default:
                break;
        }
    }

    // const getCentro = (id?:string)=> id === null ? '' : `/${id}`

    // const getLabel = useMemo(()=> `${data.idCentro}-${data.descripcion}`,[data])
    // const getJerarchy = useMemo(()=> {
    //     const CPadre = data.idCentroPadre;

    //     const CDE = getCentro(data.idCentroDE) 
    //     const CD2 = getCentro(data.idCentroD2) 
    //     const CDN = getCentro(data.idCentroDN) 
    //     const CDG = getCentro(data.idCentroDG) 
    //     const CSG = getCentro(data.idCentroSG) 

    //     return `${CPadre}${CDE}${CD2}${CDN}${CDG}${CSG}` 
    // },[data])

    return <EuiListGroupItem 
    isDisabled={ active }
    //isActive={active}
    label={data.label}
    extraAction={getRemoveAction()}
    iconType={TipoCentroIcon} 
    size='s'
    onClick={()=> !actions && onClick()}/>
}